<template>
    <div class="modal-overlay" v-if="visible" @click.self="close">
        <div class="modal-content">
            <span class="close-btn" @click="close">&times;</span>
            <h2>资产曲线</h2>
            <div class="chart-wrapper">
                <UserChart :chartData="chartData" />
            </div>
            <div class="stats-info">
                <div class="stat-item">
                    <span class="label">当前资产:</span>
                    <span class="value" :class="getProfitClass(currentProfit)">
                        {{ currentProfit }}
                    </span>
                </div>
                <div class="stat-item">
                    <span class="label">历史最大资产:</span>
                    <span class="value positive">{{ maxProfit }}</span>
                </div>
                <div class="stat-item">
                    <span class="label">历史最小资产:</span>
                    <span class="value negative">{{ minProfit }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserChart from './UserChart.vue'

export default {
    name: 'ChartModal',
    components: { UserChart },
    props: {
        visible: Boolean,
        chartData: Object
    },
    computed: {
        currentProfit() {
            if (!this.chartData.earnings || this.chartData.earnings.length === 0) return 0;
            return this.chartData.earnings[this.chartData.earnings.length - 1];
        },
        maxProfit() {
            if (!this.chartData.earnings) return 0;
            return Math.max(...this.chartData.earnings).toFixed(2);
        },
        minProfit() {
            if (!this.chartData.earnings) return 0;
            return Math.min(...this.chartData.earnings).toFixed(2);
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        getProfitClass(profit) {
            if (profit > 0) return 'positive';
            if (profit < 0) return 'negative';
            return '';
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.modal-content {
    background: #1e1e1e;
    padding: 20px;
    border-radius: 8px;
    width: 90%;
    max-width: 800px;
    position: relative;
    border: 1px solid #333;
}

.close-btn {
    position: absolute;
    top: 10px;
    right: 15px;
    font-size: 1.5rem;
    cursor: pointer;
    color: #fff;
    z-index: 10;
}

h2 {
    color: #fff;
    margin: 0 0 15px 0;
    text-align: center;
}

.chart-wrapper {
    height: 400px;
    width: 100%;
    margin-bottom: 15px;
}

.stats-info {
    display: flex;
    justify-content: space-around;
    background: #2a2d2e;
    padding: 10px;
    border-radius: 4px;
}

.stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.label {
    color: #a8a7a9;
    font-size: 12px;
    margin-bottom: 5px;
}

.value {
    font-size: 16px;
    font-weight: bold;

    &.positive {
        color: #1AB394;
    }

    &.negative {
        color: #F8AC59;
    }
}
</style>